// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609041234/js/" + chunkId + "." + {"44":"03a96ab0","225":"19fcba44","481":"6fd408bd","486":"87217df8","770":"b41bb2fe"}[chunkId] + ".0.7299555761631639.chunk.js";
};